import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatChipsModule } from '@angular/material/chips';

import { UiFormModule } from '../../../shared/ui/ui-form.module';
import { SharedModule } from '../../shared/shared.module';

import { LocationsReducer } from './store/reducers/locations.reducer';
import { LocationsEffects } from './store/effects/locations.effects';
import { LocationsService } from './services/locations.service';
import { LocationsFacade } from './services/locations.facade';

import { LocationListComponent } from './components/location-list/location-list.component';
import { LocationFormComponent } from './components/location-form/location-form.component';
import { LocationDetailComponent } from './components/location-detail/location-detail.component';

import { LocationSettingsFormComponent } from './components/location-settings-form/location-settings-form.component';
import { LocationGeneralSectionComponent } from './components/sections/location-general-section/location-general-section.component';
import { LocationMediaSectionComponent } from './components/sections/location-media-section/location-media-section.component';
import { LocationAvailabilitySectionComponent } from './components/sections/location-availability-section/location-availability-section.component';

import { LocationBrandingComponent } from '../media/components/location-branding/location-branding.component';

import { LocationScheduleComponent } from '../availability/components/location-schedule/location-schedule.component';
import { LocationExceptionsComponent } from '../availability/components/location-exceptions/location-exceptions.component';
import { LocationVacationsComponent } from '../availability/components/location-vacations/location-vacations.component';
import { LocationBlocksComponent } from '../availability/components/location-blocks/location-blocks.component';
import { LocationServiceSectionComponent } from './components/sections/location-service-section/location-service-section.component';
import { LocationStaffSectionComponent } from './components/sections/location-staff-section/location-staff-section.component';
import { LocationPaymentsSectionComponent } from './components/sections/location-payments-section/location-payments-section.component';
import { LocationPaymentsService } from './services/location-payments.service';
import { LocationReviewsSectionComponent } from './components/sections/location-reviews-section/location-reviews-section.component';
import { LocationReviewsService } from './services/location-reviews.service';
import { LocationNotificationsSectionComponent } from './components/sections/location-notifications-section/location-notifications-section.component';
import { LocationNotificationsService } from './services/location-notifications.service';

import { LocationServiceDialogComponent } from './components/sections/location-service-section/location-service-dialog.component';
import { LocationServiceBulkAddDialogComponent } from './components/sections/location-service-section/location-service-bulk-add-dialog.component';
import { LocationServiceDeleteDialogComponent } from './components/sections/location-service-section/location-service-delete-dialog.component';

import { LocationStaffDialogComponent } from './components/sections/location-staff-section/location-staff-dialog.component';
import { LocationStaffDeleteDialogComponent } from './components/sections/location-staff-section/location-staff-delete-dialog.component';

import { AvailabilityRuleDialogComponent } from './components/sections/location-availability-section/availability-rule-dialog.component';
import { ExceptionDialogComponent } from './components/sections/location-availability-section/exception-dialog.component';
import { TimeOffDialogComponent } from './components/sections/location-availability-section/timeoff-dialog.component';
import { BlockDialogComponent } from './components/sections/location-availability-section/block-dialog.component';
import { SlugOnboardingDialogComponent } from './components/sections/location-general-section/slug-onboarding-dialog.component';

@NgModule({
    declarations: [
        LocationListComponent,
        LocationFormComponent,
        LocationDetailComponent,
        LocationBrandingComponent,
        LocationScheduleComponent,
        LocationExceptionsComponent,
        LocationVacationsComponent,
        LocationBlocksComponent,
        LocationSettingsFormComponent,
        LocationGeneralSectionComponent,
        LocationMediaSectionComponent,
        LocationAvailabilitySectionComponent,
        LocationServiceSectionComponent,
        LocationStaffSectionComponent,
        LocationPaymentsSectionComponent,
        LocationReviewsSectionComponent,
        LocationNotificationsSectionComponent,
        LocationServiceDialogComponent,
        LocationServiceBulkAddDialogComponent,
        LocationServiceDeleteDialogComponent,
        LocationStaffDialogComponent,
        LocationStaffDeleteDialogComponent,
        AvailabilityRuleDialogComponent,
        ExceptionDialogComponent,
        TimeOffDialogComponent,
        BlockDialogComponent,
        SlugOnboardingDialogComponent
    ],
    exports: [
        LocationListComponent,
        LocationFormComponent,
        LocationDetailComponent,
        LocationBrandingComponent,
        LocationScheduleComponent,
        LocationExceptionsComponent,
        LocationVacationsComponent,
        LocationBlocksComponent,
        LocationSettingsFormComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        UiFormModule,
        SharedModule,
        MatInputModule,
        MatFormFieldModule,
        MatButtonModule,
        MatTableModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatToolbarModule,
        MatCardModule,
        MatDividerModule,
        MatSelectModule,
        MatDialogModule,
        MatSnackBarModule,
        MatCheckboxModule,
        MatTabsModule,
        MatDatepickerModule,
        MatProgressBarModule,
        MatTooltipModule,
        MatChipsModule,
        DragDropModule,
        StoreModule.forFeature('locations', LocationsReducer),
        EffectsModule.forFeature([LocationsEffects])
    ],
    providers: [
        LocationsService,
        LocationsFacade,
        LocationPaymentsService,
        LocationReviewsService,
        LocationNotificationsService
    ]
})
export class LocationsModule { }
